import { IVariantNameMappingData } from '../modules/mfrm-buybox/mfrm-buybox.props.autogenerated';

export const getCustomizedVariantName = (variantNameConfig: IVariantNameMappingData[] | undefined, originalVariantName: string): string | undefined => {
    const variantNameMapObject = variantNameConfig?.find((variant) => variant.originalVariantName === originalVariantName);
    if (variantNameMapObject?.originalVariantName === originalVariantName) {
        return variantNameMapObject?.customizedVariantName;
    }
    else {
        return originalVariantName;
    }
};